// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Homepage-m_I85zUVfKQY4K2kodeTe3 {
  margin-top: 5rem;
  text-align: center;
  width: 50vw;
}

.Homepage-m_oW8eGLXYBLKK4coP3scN {
  margin-bottom: 2rem;
  text-transform: capitalize;
}`, "",{"version":3,"sources":["webpack://./client/login/Homepage/Homepage.m.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B","sourcesContent":[".hero {\n  margin-top: 5rem;\n  text-align: center;\n  width: 50vw;\n}\n\n.heading {\n  margin-bottom: 2rem;\n  text-transform: capitalize;\n}"],"sourceRoot":""}]);
// Exports
export var hero = `Homepage-m_I85zUVfKQY4K2kodeTe3`;
export var heading = `Homepage-m_oW8eGLXYBLKK4coP3scN`;
export default ___CSS_LOADER_EXPORT___;
